import React from "react";
import { Redirect } from "react-router-dom";
import { isShopSectionEnabled } from "./siteContent";

/**
 * Gate /shop when the Shop section is disabled (same pattern as KidsVisibilityGate).
 */
function ShopVisibilityGate({ children }) {
  if (!isShopSectionEnabled()) {
    return <Redirect to="/home" />;
  }
  return children;
}

export default ShopVisibilityGate;
